let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4sHGL")).then(() => parcelRequire('k4nta'));